/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type { GetMeQueryResponse } from '../types/GetMe'

function getGetMeUrl() {
  const res = { method: 'GET', url: `/api/v1/me/` as const }
  return res
}

/**
 * @summary Get the current authenticated user
 * {@link /api/v1/me/}
 */
export async function getMe(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetMeQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: 'GET', url: getGetMeUrl().url.toString(), ...requestConfig })
  return res.data
}
